import { createSlice } from "@reduxjs/toolkit";
import type {
  CampaignStatus,
  GenderEnum,
  LaboratoryUserRole,
  ModuleStatus,
  ParticipationGroup,
  ParticipationStatus,
  ProfessionEnum,
  SpecialtyEnum,
  FlagCategory,
  HrdLaboratoryStatus,
  HrdFormulaireVersionStatus,
  HrdCaseStatus,
} from "@/types/api/enums";

export type EnumContextState = {
  genders: GenderEnum[];
  professions: ProfessionEnum[];
  specialties: SpecialtyEnum[];
  moduleStatuses: ModuleStatus[];
  campaignStatuses: CampaignStatus[];
  participationStatuses: ParticipationStatus[];
  laboratoryUserRoles: LaboratoryUserRole[];
  flagCategories: FlagCategory[];
  hrdLaboratoryStatuses: HrdLaboratoryStatus[];
  hrdFormulaireVersionStatus: HrdFormulaireVersionStatus[];
  hrdCaseStatus: HrdCaseStatus[];
};

const initialState: EnumContextState = {
  genders: [],
  professions: [],
  specialties: [],
  moduleStatuses: [],
  campaignStatuses: ([] = []),
  participationStatuses: [],
  laboratoryUserRoles: [],
  flagCategories: [],
  hrdLaboratoryStatuses: [],
  hrdFormulaireVersionStatus: [],
  hrdCaseStatus: [],
};

export const enumsSlice = createSlice({
  name: "enums",
  initialState,
  reducers: {
    setEnums: (state, action) => {
      return action.payload;
    },
  },
});

export const { setEnums } = enumsSlice.actions;

export default enumsSlice.reducer;
